(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/views/searchresults/receiver-search-result.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/views/searchresults/receiver-search-result.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.grassroots_shared=_svs.grassroots_shared||{};
_svs.grassroots_shared.templates=_svs.grassroots_shared.templates||{};
svs.grassroots_shared.templates.receiver_search_result = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"js-receiver-search-result\"></div>";
},"useData":true});
Handlebars.partials['svs-grassroots_shared-receiver_search_result'] = svs.grassroots_shared.templates.receiver_search_result;
})(svs, Handlebars);


 })(window);